import httpRequest from '../../common/lib/http-request';

// *************************
// QUOTE SERVICES
// *************************

function getQuoteList(associateId) {
    return httpRequest({
        url: '/Quote/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getQuoteDebitDirectConfiguration(associateId) {
    return httpRequest({
        url: '/Quote/authorization/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function generateQuotes(associateId, request) {
    return httpRequest({
        url: '/Quote/generate/' + associateId,
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getQuotesToBePayed(request) {
    return httpRequest({
        url: '/Quote',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getAssociateMissingQuotesFees(associateId) {
    return httpRequest({
        url: '/Quote/fee/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function activateQuoteDebitDirect(associateId, nib, quotePlanId, authorization, company) {
    return httpRequest({
        url: '/Quote/direct-debit/activate',
        method: 'POST',
        data: {
            associateId: associateId,
            iban: nib,
            authorization: authorization,
            quotePlan: quotePlanId,
            company: company
        }
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function cancelQuoteDebitDirect(associateId) {
    return httpRequest({
        url: '/Quote/direct-debit/cancel/' + associateId,
        method: 'POST'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getQuoteSettingList() {
    return httpRequest({
        url: '/Quote/settings',
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function generateCreditCardCheckout(checkout) {
    return httpRequest({
        url: '/Quote/cc/checkout',
        method: 'POST',
        data: checkout
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function checkAssociateEligibityForQuotePaymentPlan(associateId) {
    return httpRequest({
        url: '/Quote/payment-plan/validate/' + associateId,
        method: 'POST',
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function calculatePaymentPlanDetails(data) {
    return httpRequest({
        url: '/Quote/payment-plan/calculate',
        method: 'POST',
        data: data
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function activeQuotePaymentPlan(data) {
    return httpRequest({
        url: '/Quote/payment-plan',
        method: 'POST',
        data: data
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const QuoteService = { 
    generateQuotes, 
    getQuoteList, 
    getQuoteSettingList, 
    getQuoteDebitDirectConfiguration, 
    activateQuoteDebitDirect, 
    cancelQuoteDebitDirect, 
    getQuotesToBePayed, 
    generateCreditCardCheckout,
    getAssociateMissingQuotesFees,
    checkAssociateEligibityForQuotePaymentPlan,
    calculatePaymentPlanDetails,
    activeQuotePaymentPlan
}

export default QuoteService;